const _ = require('lodash');

function RicherRelevanceStateChanged(RREventFactory, RRPubSub) {
	this._event = RREventFactory;

	RRPubSub.channel.subscribe('TAG.#', function (data, event) {
		RREventFactory.send({
			type: event.topic.replace('TAG.', ''),
			data
		});
	});
}

RicherRelevanceStateChanged.prototype.notify = function (request) {
	if (_.isUndefined(request)) {
		throw new Error('Request cannot be undefined');
	}
	this._event.send(request);
};

module.exports = RicherRelevanceStateChanged;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-state-changed-service.js
 **/